/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  heading: {
    marginBottom: 8,
    fontWeight: 500,
    lineHeight: 1.2,
  },
  h1: {
    fontSize: 40,
  },
  h2: {
    fontSize: 32,
  },
  h3: {
    fontSize: 28,
  },
  h4: {
    fontSize: 24,
  },
  h5: {
    fontSize: 20,
  },
  h6: {
    fontSize: 16,
  },
  page: {
    padding: 20,
    fontSize: 10,
    lineHeight: 1.5,
    color: '#3E4B5B',
    flexDirection: 'column',
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  tableheader: {
    flexDirection: 'row',
    // borderBottom: '1px solid #eee',
    // backgroundColor: '#FFF',
    width: '100%',
    fontWeight: 'bold',
    backgroundColor: '#f5f6fa',
  },
  thead: {
    width: 'calc(100% / 6)',
    paddingTop: 8,
    paddingBottom: 2,
    paddingLeft: 4,
    paddingRight: 4,
    // borderWidth: 0.5,
    // borderStyle: 'solid',
    // borderColor: '#eee',
    textAlign: 'center',
    // textWrap: 'nowrap',
  },
  tablebody: {
    width: '100%',
    // border: '1px solid #666',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  tbody: {
    width: 'calc(100% / 6)',
    paddingTop: 8,
    paddingBottom: 2,
    paddingLeft: 4,
    paddingRight: 4,
    // borderWidth: 0.6,
    // borderStyle: 'solid',
    // borderColor: '#eee',
    textAlign: 'center',
  },
});

function PDFTable(props: { children: any; border?: boolean }) {
  return <View style={[styles.table, { border: props.border ? '0.5px solid #666' : '' }]}>{props.children}</View>;
}

function thead(props: { children: any }) {
  return <View style={styles.tableheader}>{props.children}</View>;
}

function tbody(props: any) {
  return <View style={[styles.tablebody]}>{props.children}</View>;
}

function row(props: any) {
  return <View style={[styles.row, { backgroundColor: props.background }]}>{props.children}</View>;
}

function th({ text, align, width }: { text: string; align?: 'center' | 'justify' | 'left' | 'right'; width?: number }) {
  return (
    <Text style={[styles.thead, { textAlign: align, width: width }]} wrap={false} hyphenationCallback={e => [e]}>
      {text}
    </Text>
  );
}

function td({ text, align, width }: { text: string; align?: 'center' | 'justify' | 'left' | 'right'; width?: number }) {
  return (
    <Text style={[styles.thead, { textAlign: align, width, textOverflow: 'ellipsis' }]} wrap={false}>
      {text}
    </Text>
  );
}

PDFTable.thead = thead;
PDFTable.tbody = tbody;
PDFTable.row = row;
PDFTable.th = th;
PDFTable.td = td;

export default PDFTable;
